import styled, { keyframes } from "styled-components";

import {
  md3CardRadius,
  md3ButtonRadius,
} from "../../../shared/styles/md3Components";
import {
  actionListSubtitle,
  fontSizes,
  lineHeights,
  sectionTitle,
} from "../../../shared/styles/typography";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export { Container } from "../../../styles/adminPage";

export const Main = styled.main`
  width: 100%;
  max-width: 680px;
  margin: 0 auto;
  padding: 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  animation: ${fadeIn} 0.6s ease-out forwards;

  @media (min-width: 768px) {
    padding: 3.2rem 2.4rem;
  }
`;

export const FormHeader = styled.header`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  padding-bottom: 1.6rem;

  h1 {
    ${sectionTitle}
    margin: 0;
  }

  p {
    ${actionListSubtitle}
    margin: 0;
  }
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  background: ${({ theme }) => theme.colors.card};
  border-radius: ${({ theme }) => md3CardRadius(theme)}px;
  padding: 2.4rem;
  box-shadow: ${({ theme }) => theme.shadows.md3Level1};
  border: 1px solid ${({ theme }) => theme.colors.border};

  .ant-form-item-label > label {
    font-weight: ${({ theme }) => theme.fontWeight.semibold};
    color: ${({ theme }) => theme.colors.textTitle};
    font-size: ${fontSizes.sm}px;
    line-height: ${lineHeights.sm}px;
  }
`;

export const MediaUploadSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  margin-top: 1.6rem;
  padding-top: 2.4rem;
  border-top: 1px dashed ${({ theme }) => theme.colors.border};
`;

export const MediaPreviewSquare = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: ${({ theme }) => md3CardRadius(theme)}px;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.surfaceTertiary};
  border: 1px solid ${({ theme }) => theme.colors.border};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.2rem;

  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const FormFooter = styled.footer`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  margin-top: 1.6rem;

  .warning-box {
    display: flex;
    align-items: center;
    gap: 1.2rem;
    background: ${({ theme }) =>
      `color-mix(in srgb, ${theme.colors.warning} 14%, transparent)`};
    padding: 1.2rem 1.6rem;
    border-radius: ${({ theme }) => md3CardRadius(theme)}px;
    border: 1px solid
      ${({ theme }) =>
        `color-mix(in srgb, ${theme.colors.warning} 28%, transparent)`};

    p {
      margin: 0;
      color: ${({ theme }) => theme.colors.warning};
      font-size: ${fontSizes.sm}px;
      line-height: ${lineHeights.sm}px;
      font-weight: ${({ theme }) => theme.fontWeight.medium};
    }
  }

  .action-buttons {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;

    button {
      width: 100%;
      height: 4.8rem;
      border-radius: ${({ theme }) => md3ButtonRadius(theme)}px;
      font-weight: ${({ theme }) => theme.fontWeight.semibold};
      font-size: ${fontSizes.base}px;
      line-height: ${lineHeights.base}px;
    }
  }

  @media (min-width: 500px) {
    .action-buttons {
      flex-direction: row;
      justify-content: flex-end;

      button {
        width: auto;
        padding: 0 3.2rem;
      }
    }
  }
`;
